import { INotification } from "@modules/notifications/model/INotifications";

import { getLabelFilialTypeList } from "@utils/enum/filial";
import { getLabelProfileTypeList } from "@utils/enum/profile";
import { getLabelSegmentTypeList } from "@utils/enum/segment";

export const buildRecipientsText = (notification: INotification): string => {
  return [
    ...notification.centers.map((item) => getLabelFilialTypeList(item)),
    ...notification.segments.map((item) =>
      toTitleCase(getLabelSegmentTypeList(item) ?? "")
    ),
    ...notification.profiles.map((item) => getLabelProfileTypeList(item)),
  ].join(", ");
};

export const toTitleCase = (value: string): string => {
  return value.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
};

export const formatDateTime = (value?: string | Date | null): string => {
  if (!value) return "-";

  const date = typeof value === "string" ? new Date(value) : value;
  if (isNaN(date.getTime())) return "-"; // opcional: trata data inválida

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${day}/${month}/${year} ${hours}:${minutes}`;
};

export const formatReadDate = (iso: string) => {
  const d = new Date(iso);

  const date = d.toLocaleDateString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });

  const time = d.toLocaleTimeString("pt-BR", {
    hour: "2-digit",
    minute: "2-digit",
  });

  return `${date} às ${time}`;
};
